import { AnimatedBackground } from "components/AnimatedBackground";
import CenteredFooter from "examples/Footers/CenteredFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import { Box, Container, Divider, Grid } from "@mui/material";
import MKTypography from "components/MKTypography";
import { CONTACT_EMAIL, TICKER } from "utils/constants";

const termsSections = [
  {
    title: "Who Can Use FartLab?",
    description:
      "To use FartLab, you must be **18 years or older**. If you're younger, you need permission from a parent or guardian. By using our site, you confirm that you meet these requirements.",
  },
  {
    title: "Changes to These Terms",
    description:
      "We might update these Terms from time to time. If you continue using FartLab after any changes, that means you accept the new terms.",
  },
  {
    title: "Access & Availability",
    description:
      "You’re responsible for having the necessary devices and internet connection to use our site. We may occasionally **take down the site for maintenance** or make changes to improve FartLab.",
  },
  {
    title: "Our Services",
    description:
      "FartLab provides access to tools for AI-generated farts, fart analysis, and our **FLART meme coin ecosystem**. Some features may require you to connect a **crypto wallet**, which is your responsibility to keep secure.",
  },
  {
    title: "Buying & Selling $FLART",
    description:
      "FartLab may allow users to **buy, sell, or trade FLART tokens**. Any purchases made on our site are **final**, and we do not offer refunds. Additional transaction fees (like gas fees) may apply.",
  },
  {
    title: "Third-Party Platforms",
    description:
      "You might buy or sell FLART on **third-party marketplaces**. These platforms are **not affiliated** with FartLab, and you use them at your own risk.",
  },
  {
    title: "User Responsibilities",
    description:
      "By using FartLab, you agree **not to** use our services for illegal activities, spread harmful content, or try to hack or disrupt the platform. We reserve the right to ban any user who violates these terms.",
  },
  {
    title: "Security",
    description:
      "We do our best to **keep FartLab secure**, but we can't guarantee that the site will always be free of viruses or interruptions. Be cautious and protect your own devices and wallets.",
  },
  {
    title: "No Financial Advice",
    description:
      "FartLab is not a **financial or investment platform**. Buying FLART tokens or using our services does **not** guarantee profits. Always do your own research before making financial decisions.",
  },
  {
    title: "Utility Token Classification",
    description:
      "$FLART is a **meme token with actual utility** - it's used exclusively to access FartLab's unique features: AI fart generation, competition entries, and community voting rights. This token **does not represent** any ownership stake or security, and its value comes solely from platform participation. You should have **no expectation of profit** from holding or using FLART tokens.",
  },
  {
    title: "Liability Limitations",
    description:
      "FartLab is not responsible for any **losses, hacks, or issues** you may experience when using our platform or connected services. Transactions are **public**, and the value of the FLART token is subject to change based on **market dynamics**.",
  },
  {
    title: "Legal Compliance",
    description:
      "You are responsible for following **all laws** related to crypto and NFTs in your country. If laws change, it may impact how you can use FartLab.",
  },
  {
    title: "Changes & Termination",
    description:
      "We may **modify or shut down FartLab** at any time. If you don’t agree with our terms, you should stop using our services.",
  },
  {
    title: "Contact Us",
    description: `For any questions about these terms, reach out to us at **${CONTACT_EMAIL}**.`,
  },
];

function TermsOfUsagePage() {
  return (
    <>
      {/* Navbar */}
      <DefaultNavbar
        routes={[]}
        // action={{
        //   type: "internal",
        //   route: "#",
        //   label: `Buy ${TICKER}`,
        //   color: "primary",
        //   disabled: true,
        // }}
        transparent
        light
      />

      {/* Main Container */}
      <AnimatedBackground
        gradients={[
          ["#4ac29a", "#bdfff3"],
          ["#6ee2f5", "#6454f0"],
        ]}
      >
        <Container sx={{ mt: "20vh", mb: "15vh", textAlign: "center" }}>
          <Grid container spacing={10} justifyContent="center">
            {/* Discord Card */}
            <Grid item xs={12} md={7}>
              {/* Privacy Title */}
              <MKTypography
                variant="h1"
                fontWeight="bold"
                color="white"
                sx={{
                  fontSize: "80px",
                  textShadow: "3px 3px black",
                  blackSpace: "pre-line",
                  letterSpacing: 1.5,
                  mb: 5,
                }}
              >
                Terms of Use
              </MKTypography>

              {/* Intro Text */}
              <MKTypography
                variant="h5"
                color="white"
                sx={{
                  textShadow: "2px 2px black",
                  blackSpace: "pre-line",
                  letterSpacing: 1.5,
                  mb: 10,
                }}
              >
                Read these terms carefully before using FartLab. By using our site, you agree to
                follow them.
              </MKTypography>

              {/* Privacy Sections */}
              {termsSections.map((section, index) => (
                <Box key={index} sx={{ textAlign: "left", mb: 5 }}>
                  <MKTypography
                    variant="h3"
                    color="white"
                    fontWeight="bold"
                    sx={{
                      textShadow: "2px 2px black",
                      letterSpacing: 1,
                      mb: 1,
                    }}
                  >
                    {section.title}
                  </MKTypography>
                  <MKTypography
                    variant="body1"
                    color="white"
                    sx={{
                      textShadow: "1px 1px black",
                    }}
                  >
                    {section.description}
                  </MKTypography>

                  {/* Divider Between Sections */}
                  {index < termsSections.length - 1 && (
                    <Divider sx={{ my: 4, border: "3px solid black", opacity: 0.6 }} />
                  )}
                </Box>
              ))}
            </Grid>
          </Grid>
        </Container>

        {/* Footer */}
        <CenteredFooter light />
      </AnimatedBackground>
    </>
  );
}

export default TermsOfUsagePage;
